import axiosInstance, { publicAxiosInstance } from "../../Utils/axios";

//for login
export const login = (body) => publicAxiosInstance.post(`api/login`, body);

//for logout
export const logout = (body) => axiosInstance.post(`api/refresh-token`, body);

//for reset password

export const changePassword = (id, body) => axiosInstance.patch(`auth/change-password/${id}`, body);

export const forgetPassword = (body) => publicAxiosInstance.post(`auth/forget-password`, body);

export const resetPassword = (otp, body) => publicAxiosInstance.post(`auth/reset-password/${otp}`, body);
